// Generated by CoffeeScript 2.7.0
var OptionsSelect;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

export default OptionsSelect = {
  components: {
    "Popover": Popover,
    "group-options": GroupOptions
  },
  props: {
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    otherOption: {
      type: Object,
      default: null
    },
    initSelectedOption: {
      type: Object
    },
    popoverPropsData: {
      type: Object
    },
    canCancelSingleSelect: {
      type: Boolean
    }
  },
  data: function() {
    return {
      selectedOption: this.initSelectedOption
    };
  },
  template: `<Popover v-bind="computedPopoverPropsData"
         type='select'
         ref='popoverRef'>
  <template slot='trigger'>
    <div class="input-control right-addon justify-box">
      <template v-if="selectedOption">
        <div class="controlled-input other-option-input-content" v-if="otherOptionSelected">
          <span class="content text-ellipsis">{{ otherOption.label }}</span>
          <input class="other-option-input"
                 type='text'
                 v-model.trim='otherOption.value'
                 @input="otherOptionValueChange"
                 placeholder="请输入"
                 ref="otherOptionInputRef" />
        </div>
        <div v-else class="controlled-input">{{ selectedOption.value }}</div>
      </template>
      <div v-else class="controlled-input placeholder">请选择</div>
      <div class="addon">
        <i class="slp-caret-down"></i>
      </div>
    </div>
  </template>
  <template slot='content'>
    <group-options :groupedOptions='groupedOptions' :multiple='false' @valueChanged="valueChangedFunc">
      <template slot='option-item-template' slot-scope='{ option }'>
        <span class="content text-ellipsis">{{ option.value }}</span>
        <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
      </template>
    </group-options>
  </template>
</Popover>`,
  computed: {
    selectedOptionId: function() {
      if (this.selectedOption) {
        return this.selectedOption.id;
      } else {
        return '';
      }
    },
    otherOptionSelected: function() {
      return this.selectedOptionId === 0;
    },
    groupedOptions: function() {
      var data;
      data = [];
      if (this.otherOption) {
        this.options.push(this.otherOption);
      }
      _.each(this.options, (option) => {
        if (option.id === this.selectedOptionId) {
          return data.push({
            id: option.id,
            value: option.textValue(true),
            name: option.label,
            _selected: true
          });
        } else {
          return data.push({
            id: option.id,
            value: option.textValue(false),
            name: option.label,
            _selected: false
          });
        }
      });
      if (_.isEmpty(data)) {
        return [];
      } else {
        return [
          {
            id: Skylark.Helpers.Utilities.uuid(),
            options: data,
            allow_clear: this.canCancelSingleSelect
          }
        ];
      }
    },
    computedPopoverPropsData: function() {
      return _.extend({
        position: 'bottom',
        caret: false,
        blockContent: true
      }, this.popoverPropsData);
    }
  },
  methods: {
    valueChangedFunc: function(vm, option) {
      this.selectedOption = option;
      this._triggerValueChange(this.selectedOption);
      if (this.otherOptionSelected) {
        this.$nextTick(function() {
          return this.$refs.otherOptionInputRef.focus();
        });
      }
      return this.$refs.popoverRef.close();
    },
    otherOptionValueChange: function() {
      return this._triggerValueChange(this.otherOption);
    },
    reset: function() {
      var ref;
      if ((ref = this.selectedOption) != null) {
        ref._selected = false;
      }
      return this.selectedOption = null;
    },
    _triggerValueChange: function(selectedOption) {
      var options;
      if (this.otherOptionSelected) {
        return this.$emit('valueChange', [this.otherOption]);
      } else if (selectedOption) {
        options = _.filter(this.options, function(item) {
          return item.id === selectedOption.id;
        });
        return this.$emit('valueChange', options);
      }
    }
  }
};
